import React, { useRef, useState, useEffect } from "react";
import { Box } from "@mui/material";
import { ShipmentTimelineWithThreadLines } from "@shared/shipments/timelineWithThreadLinesComponent";

interface ResponsiveTimelineWrapperProps {
  shipmentId: string;
  isAdmin?: boolean;
  filtersCollapsible?: boolean;
  inlineDates?: boolean;
  onOpenEmail?: (emailId: string) => void;
}

function computeLayoutProps(width: number) {
  if (width < 500) {
    // Narrow (plugin): tight spacing, wider bubbles
    return {
      numberOfLanes: 3,
      laneSpacing: 16,
      laneThickness: 8,
      lanesLeftOffset: 4,
      bubbleWidth: 72,
      bottomPadding: 56,
    };
  }
  // Wide (sidebar/full page): use component defaults
  return {};
}

export const ResponsiveTimelineWrapper: React.FC<ResponsiveTimelineWrapperProps> = ({
  shipmentId,
  isAdmin,
  filtersCollapsible,
  inlineDates,
  onOpenEmail,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setWidth(entry.contentRect.width);
      }
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Box ref={containerRef} sx={{ flex: 1, minHeight: 0, height: "100%" }}>
      {width > 0 && (
        <ShipmentTimelineWithThreadLines
          shipmentId={shipmentId}
          isAdmin={isAdmin}
          filtersCollapsible={filtersCollapsible}
          inlineDates={inlineDates}
          onOpenEmail={onOpenEmail}
          {...computeLayoutProps(width)}
        />
      )}
    </Box>
  );
};
